<form *ngIf='form as form' [formGroup]='form' (ngSubmit)='submit()' autocomplete='off' novalidate>
  <fieldset>
    <legend>Dane podstawowe</legend>
    <div class='row'>
      @if (form.surfaceViolation) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"surfaceViolation" as controlName'>
            <label [for]='controlName'>Rodzaj *</label>
            <select
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz rodzaj</option>
              <option value='Bez naruszenia nawierzchni'>Bez naruszenia nawierzchni</option>
              <option value='Powodujące naruszenie nawierzchni'>Powodujące naruszenie nawierzchni</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.occupationType) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"occupationType" as controlName'>
            <label [for]='controlName'>Rodzaj *</label>
            <select
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [id]='controlName'
              [formControlName]='controlName'>
              <option value=''>Wybierz rodzaj</option>
              <option *ngFor='let item of roadOccupationTypes()' [value]='item?.id'>
                {{ item?.name }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.purpose) {
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"purpose" as controlName'>
            <label [for]='controlName'>
              Cel zajęcia *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu cel zajęcia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.workPurpose) {
        @if (workPurposeControlType === 'select') {
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"workPurpose" as controlName'>
              <label [for]='controlName'>Cel prowadzenia robót *</label>
              <select
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [id]='controlName'
                [formControlName]='controlName'>
                <option value=''>Wybierz cel</option>
                <option value='Umieszczenie kontenera'>Umieszczenie kontenera</option>
                <option value='Umieszczenie rusztowania'>Umieszczenie rusztowania</option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (workPurposeControlType === 'textarea') {
          <div class='col-12'>
            <div class='form-group' *ngIf='"workPurpose" as controlName'>
              <label [for]='controlName'>
                Cel prowadzenia robót *
              </label>
              <textarea
                rows="5"
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu cel prowadzenia robót'></textarea>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      }
      @if (form.deviceType) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"deviceType" as controlName'>
            <label [for]='controlName'>
              Rodzaj urządzenia *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu rodzaj urządzenia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    @if (form.showDecisionControls()) {
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"locationDecisionNumber" as controlName'>
            <label [for]='controlName'>
              Numer decyzji lokalizacyjnej *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu numer decyzji lokalizacyjnej'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"locationDecisionDate" as controlName'>
            <label [for]='controlName'>
              Data wydania decyzji lokalizacyjnej *
            </label>
            <app-date-picker
              [id]='controlName'
              [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (form.showAgreementControls()) {
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"agreementNumber" as controlName'>
            <label [for]='controlName'>
              Numer uzgodnienia *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu numer uzgodnienia'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"agreementDate" as controlName'>
            <label [for]='controlName'>
              Data wydania uzgodnienia *
            </label>
            <app-date-picker
              [id]='controlName'
              [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    }
  </fieldset>
  <br>
  <fieldset>
    <legend>
      Etapy
    </legend>
    <app-tab-view
      [simple]='false'
      (onAddNew)='form.addStage()'
      addBtnTitle='Dodaj kolejny etap'
      [showAddButton]='true'
      [centered]='true'
      formArrayName='stages'>
      <ng-container *ngFor='let stageForm of form.getStageForms(); let i = index;'>
        <app-tab-panel
          (onClose)='form.removeStage(i)'
          [closeBtnDisabled]='i === 0'
          [showCloseBtn]='true'
          [name]='"Etap nr " + (i + 1)' [selected]='i === (form.stages.controls.length - 1)'>
          <app-stage-form
            [label]='"Etap nr " + (i + 1)'
            [canRemoveStage]='i !== 0'
            [form]='stageForm'>
          </app-stage-form>
        </app-tab-panel>
      </ng-container>
    </app-tab-view>
  </fieldset>
  <br>
  <div class='form-actions'>
    @if (showCancel) {
      <button type='button' class='btn btn-secondary' (click)='cancel()'>
        <i class='fa fa-ban'></i>Anuluj
      </button>
    }
    <button type='submit' class='btn btn-secondary' *ngIf='edit'>
      <i class='fa fa-save'></i>Zaktualizuj dane
    </button>
    <button type='submit' class='btn btn-secondary' *ngIf='!edit'>
      <i class='fa fa-plus'></i>Dołącz do wniosku
    </button>
  </div>
</form>
